import React from 'react';
import {
    Header,
    Grid, Segment,
    Button,
    Icon, Form, Dropdown, Table, Popup, Loader
} from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';


import { Link } from 'react-router-dom';
import moment from 'moment';

import ReactExport from 'react-data-export';
import SearchTableData from "../../../util/SearchTableData";
import PaginationFront from "../../../util/PaginationFront";
import { sanitizeExcelDataSet } from '../../../util/sanitizeExcel';

const { ExcelFile } = ReactExport;
const { ExcelSheet } = ReactExport.ExcelFile;
const { ExcelColumn } = ReactExport.ExcelFile;


export default class ArchivedPollList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            archivedPoll: [],
            loader: true,
            results: [],

            activePage: 1,
            postsPerPage: 20,
            currentPosts: [],

            excelData: []

        };
        this.getDataToRender = this.getDataToRender.bind(this);
        this.getArchivedPoll = this.getArchivedPoll.bind(this);
        this.getResults = this.getResults.bind(this);
    }

    componentDidMount() {
        this.getArchivedPoll();
    }

    getArchivedPoll() {
        let status = this.props.statuses.find((e) => e.key === 'archived');
        localStorage.setItem('pollStatus', status.value);
        axios.get(`/questionnaire/all/${status.value}/`)
            .then(res => {
                this.setState({
                        archivedPoll: res.data.map(el => ({
                            ...el,
                            activationDate: el.activationDate ? moment(el.activationDate).format('D. M. YYYY.') : '',
                            endDate: el.endDate ? moment(el.endDate).format('D. M. YYYY.') : '',
                        })),
                        loader: false,
                    },
                    ()=>{
                        this.setState({
                            excelData:  this.state.archivedPoll.map((el, index) => ([
                                { value: (index + 1) + '.'},
                                { value: el.name},
                                { value: el.questionnaireType.name},
                                { value: el.activationDate},
                                { value: el.endDate}
                            ]))})
                    });
            })
            // }
            //     const archivedPoll = res.data;
            //     this.setState({ archivedPoll, loader: false });
            // })
            .catch(err => {
                this.setState({ loader: false });
                toast('Došlo je do greške. Nije moguće prikazati prethodne ankete.');
                console.log('Failed to fetch archived poll.');
            });
    }

    // getDataToRender() {
    //     if (this.state.showFiltersOnButton) {
    //         return this.state.filterData;
    //     }
    //     return this.state.archivedPoll;
    // }

    getDataToRender() {
        if (this.state.results.length !== 0) {
            return this.state.results;
        }
        return this.state.archivedPoll;
    }

    getResults(results) {
        if(results.length === 0)
        {
            this.setState({
                results: [],
                excelData: this.state.archivedPoll.map((el, index) => ([
                    { value: (index + 1) + '.'},
                    { value: el.name},
                    { value: el.questionnaireType.name},
                    { value: el.activationDate},
                    { value: el.endDate}

                ]))});
        }
        else {
            this.setState({ results,
                excelData:  results.map((el, index) => ([
                    { value: (index + 1) + '.'},
                    { value: el.name},
                    { value: el.questionnaireType.name},
                    { value: el.activationDate},
                    { value: el.endDate}

                ]))});
        }
        this.handlePaginationChange({}, {activePage: 1})
    }

    handlePaginationChange = (e, { activePage }) => this.setState({ activePage })

    render() {
        const indexOfLastPost = this.state.activePage * this.state.postsPerPage;
        const indexOfFirstPost = indexOfLastPost - this.state.postsPerPage;
        const currentPosts = this.getDataToRender().slice(indexOfFirstPost, indexOfLastPost);

        const multiDataSet = [
            {
                columns: [
                    { title: 'R. br.', width: { wpx: 50 } },
                    { title: 'Naziv', width: { wpx: 700 } },
                    { title: 'Tip', width: { wpx: 200 } },
                    { title: 'Datum objave studentima', width: { wpx: 200 } },
                    { title: 'Datum isteka', width: { wpx: 200 } },
                ],
                data: this.state.excelData,
            }
        ];
        return (

            <div>


                { this.state.loader ? <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader  size="medium" active /></div> : this.getDataToRender().length ? <Table celled selectable compact>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell colSpan={15} >
                                <Grid column={2} stackable>
                                    <Grid.Column width={14}>
                                        <SearchTableData profMozilla data={this.state.archivedPoll} getResults={this.getResults} filterItem={['name']} />
                                    </Grid.Column>
                                    <Grid.Column width={2} textAlign="center">
                                        <ExcelFile filename={'Spisak prethodnih anketa'} element={<Popup
                                            trigger={<Button animated="vertical" color='green' basic floated='right' fluid style={{ textAlign: 'center' }}>
                                                <Button.Content hidden> <Icon name="download" /></Button.Content>
                                                <Button.Content visible>
                                                    Excel
                                                </Button.Content>
                                            </Button>}
                                            content="Preuzmi spisak u Excel-u"
                                            hideOnScroll
                                            position="top center"
                                        />}>
                                            <ExcelSheet dataSet={sanitizeExcelDataSet(multiDataSet)} name={'Ankete'} />
                                        </ExcelFile>

                                    </Grid.Column>
                                </Grid>
                            </Table.HeaderCell>
                        </Table.Row>
                        <Table.Row>
                            <Table.HeaderCell width={1} colSpan={1}>
                                R. br.
                            </Table.HeaderCell>
                            <Table.HeaderCell colSpan={5}>
                                Naziv
                            </Table.HeaderCell>
                            <Table.HeaderCell colSpan={3}>
                                Tip
                            </Table.HeaderCell>
                            <Table.HeaderCell colSpan={2}>
                                Datum objave
                            </Table.HeaderCell>
                            <Table.HeaderCell colSpan={2}>
                                Datum isteka
                            </Table.HeaderCell>

                            <Table.HeaderCell colSpan="2" ></Table.HeaderCell>


                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {/*{this.getDataToRender().map((el, index) =>*/}
                        {currentPosts.map((el, index) =>
                            (<Table.Row key={index}>
                                <Table.Cell width={1} colSpan={1} verticalAlign="middle">  {(index + 1) + ((this.state.activePage - 1) * this.state.postsPerPage)}. </Table.Cell>
                                <Table.Cell verticalAlign="middle" colSpan={5}>
                                    {el.name}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" colSpan={3}>
                                    {el.questionnaireType.name}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" colSpan={2}>
                                    {/*{moment(el.activationDate).format('D. M. YYYY.')}*/}
                                    {el.activationDate}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" colSpan={2}>
                                    {/*{moment(el.endDate).format('D. M. YYYY.')}*/}
                                    {el.endDate}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" textAlign="center" colSpan="2">
                                    {/* link */}
                                    <Link to={{ pathname: '/ankete/detalji' }}>
                                        <Popup
                                            content={'Detalji ankete'}
                                            position="top center"
                                            trigger={
                                                <span><Button
                                            basic="true"
                                            circular
                                            icon="align justify"
                                            size="small"
                                            color="blue"
                                            onClick={() => { // seta se flag da se moze editovati
                                                let poll = {
                                                    pollId: el.id,
                                                    pollName: el.name,
                                                    pollType: el.questionnaireType.id,
                                                    pollStatus: el.questionnaireStatus.id,
                                                };
                                                localStorage.setItem('poll', JSON.stringify(poll));
                                                localStorage.setItem('edit', 'disable');
                                                localStorage.removeItem('delete');
                                            }}
                                        >
                                                </Button></span>}/>
                                    </Link>


                                </Table.Cell>
                            </Table.Row>))}
                    </Table.Body>
                </Table> : 'Trenutno nema arhiviranih anketa.'}

                {currentPosts.length > 0 && <PaginationFront postsPerPage={this.state.postsPerPage} totalPosts={this.getDataToRender().length} paginate={this.handlePaginationChange} activePage={this.state.activePage} />}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Poll/AdminPoll/PollTabs/ArchivedPollList.js